import { ProfileMenu } from "./profile";
import { validateMobileNumber } from "./../helpers/validation";

import sbfMapping from "./../const/mappings/pb001-sbf.json";
import unoMapping from "./../const/mappings/pb001-uno.json";
import rfcMapping from "./../const/mappings/rw001.json";

import REGEX from "./../const/regex";
import ERROR from "./../const/error";
import * as OPTIONS from "./../const/application.js";

export const applicationInfoMap = {
    applicAmount: "amount",
    applicLoanPurposeD: "categories",
    applicLoanPurpose: "categories",
    applicLoanTerm: "term",
    applicRepayType: "repayType",
    newToUBP: "no",
    newToBank: "no",
    applicMthAmort: "amortization",
    applicRebate: "rebate",
    applicCustCatD: "loanType",
    loanCollatDetsBlockNo: "creditScore",
};

export const applicationForceType = {
    applicAmount: "numeric",
    applicLoanTerm: "numeric",
    personBirthdate: "datetime",
    personSpouseBirthdate: "datetime",
    personMobileNo: "mobile",
    companySpouseMobileNo: "mobile",
    personMonthlyIncome: "currency",
    companyECommChannelID: "json-string",
    personRefMobile1: "mobile",
    personRefMobile2: "mobile",
    personRefMobile3: "mobile",
};

export const applicationForceFieldType = {
    companyOSDebt: "Float",
    companyBizPeriodCurrAddr: "Integer",
    comaker1PDDateOfBirth: "birthday",
    comaker1CDMobilePhoneNo: "Mobile",
    personRefMobile1: "Mobile",
    personRefMobile2: "Mobile",
    personRefMobile3: "Mobile",
    companyRegSet1: "Integer",
    companyReg: "Integer",
    companyEmail: "Email",
    companyBizPeriodCurrAddrSet1: "Integer",
};

export const applicationScoreCardTab = { "UBP001": 1, "UBP001_FOODPND": 1, "UBP001_UBX": 1 };

export const applicationQuickLoansCardTab = { "UBP001_UBX": 2 };

export const applicationOTPLength = 6;
export const applicationOTPType = "numeric"; // alpha, numeric, alpha-numeric
export const applicationOTPRetry = 3;
export const applicationOTPRetryDelay = 60;
export const applicationOTPCookieVar = "loan-otp";
export const applicationOTPRetryCookieVar = "loan-otp-retry";

const applicationMenu = JSON.parse(JSON.stringify(ProfileMenu)); // Javacript's best way to clone an object

applicationMenu["documents"]["component"] = "DocumentsIndex";
applicationMenu["documents"]["previous"] = ["employment", "emp-other-info"];

delete applicationMenu["documents"]["items"];

applicationMenu["employment"]["items"]["emp-other-info"]["next"] = ["documents"];

export const ApplicationMenu = applicationMenu;

export const ApplicationValidation = {
    "companyOfcMobileNo": validateMobileNumber,
    "companyEmpOfcMobileNo": validateMobileNumber,
    "companySuppMobileNo": validateMobileNumber,
    "comaker1CDMobilePhoneNo": validateMobileNumber,
    "personGSISID": {
        "^[0-9]{11}$": "GSIS format should be 12312312312",
    },
    "personSpouseFirstName": {
        "^[A-Za-z ]+$": "Please use only letters (A to Z) and spaces for this field",
    },
    "personSpouseMiddleName": {
        "^[A-Za-z ]+$": "Please use only letters (A to Z) and spaces for this field",
    },
    "personSpouseLastName": {
        "^[A-Za-z ]+$": "Please use only letters (A to Z) and spaces for this field",
    },
    "personSpouseTaxRef": {
        "^[0-9]{9}$": "TIN format should be 123-123-123-123",
    },
    "personSpouseSSSUMID": {
        "^[0-9]{2}-[0-9]{7}-[0-9]$": "SSS format should be 12-1234567-1",
    },
    "personSpouseGSIS": {
        "^[0-9]{11}$": "GSIS format should be 11 numeric characters",
    },
    "companyOSDebt": {
        [REGEX["decimal"]]: ERROR["InvalidNumber"],
    },
    // "companyBizPeriodCurrAddr": {
    //     [REGEX["numeric"]]: ERROR["InvalidNumber"],
    // },
};

export const ApplicationReadOnly = {
    "personFullNameID": {
        "source": [
            "representative-first-name",
            "representative-middle-name",
            "representative-last-name",
            "representative-suffix-name",
        ],
    },
    "vehicleModel": {
        "source": [],
    },
    "vehiclePrice": {
        "source": [],
    },
    "vehicleDP": {
        "source": [],
    },
    "branchCode": {
        "source": [],
    },
};

export const ApplicationMenuToggle = {
    "representative|spouse-info": {
        personCivilStatus: {
            _default: false,
            married: true,
        },
    },
    "business|basic-info": {
        companySelfEmployedD: { _default: true, yes: true, no: false },
    },
    "business|address": { companySelfEmployedD: { _default: true, yes: true, no: false } },
    "business|financial-info": { companySelfEmployedD: { _default: true, yes: true, no: false } },
    "business|other-info": { companySelfEmployedD: { _default: true, yes: true, no: false } },
    "business|digital-platforms": {
        companySelfEmployedD: { _default: true, yes: true, no: false },
        companyECommChannel: { _default: false, yes: true },
    },
    "employment|emp-basic-info": { companySelfEmployedD: { _default: false, no: true } },
    "employment|emp-address-contact": { companySelfEmployedD: { _default: false, no: true } },
    "employment|emp-financial-info": { companySelfEmployedD: { _default: false, no: true } },
    "employment|emp-other-info": { companySelfEmployedD: { _default: false, no: true } },
};

export const ApplicationFormCustomProfileFields = {
    "employment-company-industry": [
        {
            code: "companySubIndustry",
            profileField: "employment_company_subindustry",
            formField: "employment-company-subindustry",
        },
    ],
};

export const ApplicationFormCustomFields = {
    "_default": {
        "companyIndustry": [
            {
                "isRequired": true,
                "code": "companySubIndustry",
                "label": "Sub-Industry",
                "dataType": "Text",
                "fieldType": "Dropdown",
                "optionsGroup": "natureOfSubBiz_option",
                "renderOptions": {
                    "filter": "industry", // targetOptionVariable
                    "source": "companyIndustry",
                },
            },
        ],
        "referralCode": [
            {
                "isRequired": false,
                "code": "referralCode",
                "label": "Referral Code",
                "dataType": "Text",
                "fieldType": "InputField",
                "tabName": "Personal Information",
                "validate": { "^[a-zA-Z0-9]{6,6}$": "Invalid referral code" },
            },
        ],
    },
    "EF002": { "referralCode": [] },
};

export const ApplicationFormProfileMap = {
    "_default": {
        "personSuffix": "borrower_suffix",
        "addressCtyD": "borrower_birthcountry",
    },
};

export const tempDocumentFieldMap = {
    attchImgId: "id_photo",
    attchDTISECCert: "dti_certificate",
    attchBizPermit: "mayors_permit",
    attchSalesProof: "sales_proof",
    attchBillingProof: "electricity_bill",
    attchISP: "internet_bill",
    attchBizPlcPhotoInt: "business_location_photo",
    attchBizPlcPhotoExt: "business_location_photo",
};

export const ReUpdateFieldTrigger = "_added-field_";
export const ReUploadFieldTrigger = "re-upload document";
export const ResubmitTextWarning = "Please edit this field";
export const ReUploadTextWarning = "Please re-upload document/s on this field";

export const ApplicationForm = {
    "companyIsRegistered": {
        TO001_SO001: {
            captionMD: "See the list of requirements here. [List of requirements](#loan-requirements-modal)",
        }, // unit test
        SI001: {
            captionMD: "See the list of requirements here. [List of requirements](#loan-requirements-modal)",
        },
    },
    "personDependent": {
        "_default": {
            max: 99,
        },
    },
    "companyBizPeriodCurrAddr": {
        "_default": {
            max: 99,
        },
    },
    "companyBizPeriodCurrAddrSet1": {
        "_default": {
            max: 99,
        },
    },
    "houseInfos_occupancyPeriod": {
        "_default": {
            max: 99,
        },
    },
};

export const ApplicationFormSummary = {
    "representative": {
        title: "Representative",
        items: [
            {
                title: "Personal Information",
                fields: {
                    "representative-full-name": {
                        label: "Full Name",
                        source: [
                            "representative-first-name",
                            "representative-middle-name",
                            "representative-last-name",
                            "representative-suffix-name",
                        ],
                    },
                    "representative-birthdate": {
                        label: "Birthdate",
                        format: "date",
                    },
                    "representative-birthplace": {
                        label: "Birthplace",
                    },
                    "representative-gender": {
                        label: "Gender",
                    },
                    "representative-civil-status": {
                        label: "Civil Status",
                    },
                },
            },
            {
                title: "Address and Contact",
                fields: {
                    "representative-complete-address": {
                        label: "Address",
                        longField: true,
                        source: [
                            "representative-address1",
                            "representative-address2",
                            "representative-address-barangay",
                            "representative-address-village",
                            "representative-address-city",
                            "representative-address-province",
                        ],
                        separator: ", ",
                        format: "address",
                    },
                    "representative-email": {
                        label: "Email Address",
                    },
                    "representative-mobile": {
                        label: "Mobile Number",
                    },
                },
            },
            {
                title: "Work Information",
                fields: {
                    "representative-employment-status": {
                        label: "Employment Status",
                    },
                    "representative-occupation": {
                        label: "Occupation",
                    },
                    "representative-monthly-income": {
                        label: "Estimated Revenue per month",
                        format: "amount",
                    },
                },
            },
            {
                title: "Government Information",
                fields: {
                    "representative-filipino-citizen": {
                        label: "Citizenship",
                    },
                    "representative-tin": {
                        label: "TIN Number",
                    },
                    "representative-sss": {
                        label: "SSS Number",
                    },
                },
            },
        ],
    },
    "business": {
        title: "Business",
        items: [
            {
                title: "Basic Business Information",
                fields: {
                    "business-has-digital-channels": {
                        label: "Do you have other online shops?",
                    },
                    "business-type": {
                        label: "Type of business",
                    },
                    "business-name": {
                        label: "Business Name",
                    },
                    "business-industry": {
                        label: "Industry",
                        longField: true,
                    },
                },
            },
            {
                title: "Business Address",
                fields: {
                    "business-complete-address": {
                        label: "Address",
                        longField: true,
                        source: [
                            "business-address1",
                            "business-address2",
                            "business-city",
                            "business-province",
                            "business-region",
                            "business-country",
                        ],
                        separator: ", ",
                        format: "address",
                    },
                    "business-zip": {
                        label: "Zip Code",
                    },
                    "business-establishment": {
                        label: "Business Establishment",
                    },
                },
            },
        ],
    },
};

export const ApplicationLocationOptions = {
    "representative-birthplace": "city",
    "representative-address-province": "province",
    "representative-address-city": "city",
    "business-country": "country",
    "business-region": "region",
    "business-province": "province",
    "business-city": "city",
};

export const ApplicationDropdownOptions = {
    "representative-gender": OPTIONS.ApplicationGenderOptions,
    "representative-civil-status": OPTIONS.ApplicationCivilStatusOptions,
    "representative-employment-status": OPTIONS.ApplicationEmploymentStatusOptions,
    "representative-filipino-citizen": OPTIONS.ApplicationNationalityOptions,
    "business-type": OPTIONS.ApplicationBusinessTypeOptions,
    "business-industry": OPTIONS.ApplicationBusinessIndustryOptions,
    "business-establishment": OPTIONS.ApplicationBusinessEstablishmentOptions,
};

export const ApplicationSummaryFieldExceptions = ["personFullNameID"];

export const ApplicationFormForceUpdate = {
    "representative-first-name": { "personFullNameID": ApplicationReadOnly["personFullNameID"] },
    "representative-middle-name": { "personFullNameID": ApplicationReadOnly["personFullNameID"] },
    "representative-last-name": { "personFullNameID": ApplicationReadOnly["personFullNameID"] },
    "representative-suffix-name": { "personFullNameID": ApplicationReadOnly["personFullNameID"] },
};

export const ApplicationReSubmitBoundFields = {
    "representative-address-province": ["representative-address-city"],
    "representative-address-city": ["representative-address-province"],
    "business-city": ["business-region", "business-province", "business-zip"],
    "business-province": ["business-region", "business-city", "business-zip"],
    "business-region": ["business-province", "business-city", "business-zip"],
};

export const ValidProfileCheckFields = ["representative-birthdate", "business-province"];

export const ApplicationSubmissionRedirect = {
    PB001: {
        popup: "https://kayamo.com.ph/?referrer=seekcap",
    },
};

export const ApplicationCustomValueMapping = {
    "PB001_SBF": sbfMapping,
    "SB002_SBF": sbfMapping,
    "PB001_UNO": unoMapping,
    "UN002_UNO": unoMapping,
    "RW001": rfcMapping,
    "RW002": rfcMapping,
};

export const ApplicationForceDropdown = {
    "PB001_UNO": {
        personDesignation: "occupation_option",
        personHighestQualification: "employmentStatus_option",
    },
    "UN002_UNO": {
        personDesignation: "occupation_option",
        personHighestQualification: "employmentStatus_option",
    },
    "RW001": {
        personRefName2: "religion_option",
        personHighestQualificationT: "personHighestQualification_options",
        personIncomeSrcD: "incomeSource_option",
        companyDesignation: "employmentStatus_option",
        applicCustCatD: "loanPurpose_option",
        collateralSecurityTypD: "collateral_option",
        applicAgentName: "realEstate_option",
    },
    "RW002": {
        personRefName2: "religion_option",
        personHighestQualificationT: "personHighestQualification_options",
        personIncomeSrcD: "incomeSource_option",
        companyDesignation: "employmentStatus_option",
        applicCustCatD: "loanPurpose_option",
        collateralSecurityTypD: "collateral_option",
        applicAgentName: "realEstate_option",
    },
};

export const ApplicationFormCustomMenu = {
    "_default": {},
    "EF002": {
        "representative": {
            "items": {
                "address-contact": {
                    "title": "Contact Details",
                },
            },
        },
    },
};
